export const defaultFieldOptions = {
  trigger: "onBlur",
  valuePropName: "defaultValue",
  initialValue: 0,
};
export const grondSoort = {
  1: "Veen",
  2: "Klei",
  3: "Zand",
  4: "Löss",
};

export const methodes = { 0: "2020", 1: "2021", 2: "Onbekend" };

export const fosfaatklasses = [
  { id: 8, omschrijving: "Fosfaat hoog" },
  { id: 7, omschrijving: "Fosfaat ruim" },
  { id: 6, omschrijving: "Fosfaat neutraal" },
  { id: 5, omschrijving: "Fosfaat laag" },
  { id: 4, omschrijving: "Fosfaat arm" },
];

export const grondsoorten = [
  { id: 1, omschrijving: "Aandeel veen" },
  { id: 2, omschrijving: "Aandeel klei" },
  { id: 3, omschrijving: "Aandeel zand, nat (II-V)" },
  { id: 4, omschrijving: "Aandeel zand, matig droog (VI)" },
  { id: 5, omschrijving: "Aandeel zand, droog (VII-VIII)" },
];

export const kenmerkenGronden = [
  { id: 1, omschrijving: "Kustvlakte veen" },
  { id: 2, omschrijving: "Aandeel moerig in minerale gronden" },
]

export enum InvoerTables {
  Regio = 0,
  Monsters = 1,
}

export const invoerwaardesColumnNames = [
  {
    table: InvoerTables.Regio,
    kenmerkenMineralenGrondBodemCategorie: 1,
    title: "o.s."
  },
  {
    table: InvoerTables.Regio,
    kenmerkenMineralenGrondBodemCategorie: 2,
    title: "SOC"
  },
  {
    table: InvoerTables.Regio,
    kenmerkenMineralenGrondBodemCategorie: 3,
    title: "Lutum"
  },
  {
    table: InvoerTables.Regio,
    kenmerkenMineralenGrondBodemCategorie: 4,
    title: "C/N"
  },
  {
    table: InvoerTables.Monsters,
    kenmerkenMineralenGrondBodemCategorie: 5,
    title: "o.s."
  },
  {
    table: InvoerTables.Monsters,
    kenmerkenMineralenGrondBodemCategorie: 6,
    title: "SOC"
  },
  {
    table: InvoerTables.Monsters,
    kenmerkenMineralenGrondBodemCategorie: 7,
    title: "Lutum"
  },
  {
    table: InvoerTables.Monsters,
    kenmerkenMineralenGrondBodemCategorie: 8,
    title: "C/N"
  },
];

export const grondgebruiken = [
  "grasland",
  "natuurgrasland",
  "akkerbouw",
  "snijmaisland",
];

export const bodemkoolstofInvoerRows = [
  {
    title: "Natuur grasland",
    key: "natuurWaarde",
  },
  {
    title: "Continue grasland",
    key: "grasConWaarde",
  },
  {
    title: "Wisselteelt grasland",
    key: "grasWisWaarde",
  },
  {
    title: "Continue bouwland",
    key: "bouwConWaarde",
  },
  {
    title: "Wissel bouwland",
    key: "bouwWisWaarde",
  },
];

export const gewastypes = [
  {
    title: "Productiegrasland",
    formKey: "grasland",
  },
  {
    title: "Snijmais",
    formKey: "snijmais",
  },
  {
    title: "Akkerbouw",
    formKey: "akkerbouw",
  },
];
